import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "md:flex flex-col md:flex-row md:min-h-screen mt-0 mx-4" }
const _hoisted_2 = {
  class: "md:col-span-1 md:grid-cols-1",
  style: {"display":"unset"}
}
const _hoisted_3 = { class: "mx-auto w-full col-start-2 md:col-span-6 md:grid-cols-6 justify-self-center lg:justify-self-stretch" }
const _hoisted_4 = { class: "flex-col sm:flex-row md:items-center md:flex flex-wrap justify-center items-center justify-center" }
const _hoisted_5 = { class: "dark:text-gray-400" }
const _hoisted_6 = { class: "pt-16 sm:pt-16 md:pt-5 lg:pt-0 pb-0 container py-6 px-3 mx-auto flex flex-wrap flex-col md:flex-row lg:w-full" }
const _hoisted_7 = { class: "w-full py-3 md:py-0 sm:pb-10 lg:py-6 max-w-2xl my-2" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "pt-0 pb-0 container py-6 px-3 mx-auto flex flex-wrap\n    flex-col md:flex-row lg:w-full xl:pr-64" }
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "visible sm:invisible container px-3 mx-auto flex flex-wrap flex-col md:flex-row lg:w-3/4 md:items-center mb-3" }, null, -1)
const _hoisted_14 = { class: "pt-16 md:pt-6 pb-0 container py-6 px-3 mx-auto flex flex-wrap\n    flex-col md:flex-row lg:w-full xl:pr-64" }
const _hoisted_15 = { class: "mb-2" }
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "visible sm:invisible container px-3 mx-auto flex flex-wrap flex-col md:flex-row lg:w-3/4 md:items-center mb-3" }, null, -1)
const _hoisted_18 = { class: "pt-0 pb-0 container py-6 px-3 mx-auto flex flex-wrap\n    flex-col md:flex-row lg:w-full xl:pr-64" }
const _hoisted_19 = { class: "mb-2" }
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "visible sm:invisible container px-3 mx-auto flex flex-wrap flex-col md:flex-row lg:w-3/4 md:items-center mb-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar = _resolveComponent("sidebar")
  const _component_default_button = _resolveComponent("default-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_sidebar)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", null, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t("support.SupportTitle")), 1)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", null, [
                _createVNode("h1", _hoisted_10, _toDisplayString(_ctx.$t("support.eMailSupport")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("support.eMailInfo")), 1),
                _hoisted_11
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_default_button, {
                  "button-text": _ctx.$t('support.eMailBtn'),
                  "button-width": "w-auto",
                  "button-x-padding": "p-6"
                }, null, 8, ["button-text"])
              ]),
              _hoisted_13
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", null, [
                _createVNode("h1", _hoisted_15, _toDisplayString(_ctx.$t("support.phoneSupport")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("support.phoneInfo")), 1),
                _hoisted_16
              ]),
              _hoisted_17
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("div", null, [
                _createVNode("h1", _hoisted_19, _toDisplayString(_ctx.$t("support.chatSupport")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("support.chatInfo")), 1),
                _hoisted_20
              ]),
              _hoisted_21
            ])
          ])
        ])
      ])
    ])
  ]))
}